import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D284 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D284 - Software Engineering
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
          <i class="fa-regular fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 4.10 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Fun course. Basically, you have a company needing a CRM system, and
            your job is to either create a new CRM or choose an existing one
            that fits their needs. In my case, I’ve used quite a few CRMs like
            Salesforce, Jira, Dynamics 365, Monday, Slack, etc. I chose
            Microsoft Dynamics 365 and expanded on it. Use the template given to
            you and fill it out as you go along. It’s basically writing a report
            and proposing your CRM to this company.
          </p>
          <p>Breakdown of the sections:
            <ul>
              <li>A1 – Introduce the CRM and summarize why it’s a good fit.</li>
              <li>A2 – List the company's problems and how your CRM will solve them <i>(high level).</i></li>
              <li>A3 – Separate goals (what the company needs) from objectives (specific implementation details).</li>
              <li>A4 – Define system requirements (e.g., Windows OS, 15GB RAM minimum). Also, create a timeline (e.g., 2 weeks before deployment, 4 weeks before deployment, etc.).</li>
              <li>A5 – Explain what your CRM will cover and what it won't (think outside the box for exclusions).</li>
              <li>A6 – Define the environment (e.g., frontend is a browser, backend is hosted on AWS/Azure, etc.).</li>
              <li>B – This is up to you—come up with something relevant.</li>
              <li>C – Choose a development methodology, explain its advantages and disadvantages.</li>
              <li>D –
                <ul><li>Diagram 1: Ticketing system flowchart (I made one with 4 rectangles and arrows showing the steps).</li>
                <li>Diagram 2: ERD diagram (Used lucidchart.com for this).</li></ul>
              </li>
              <li>Last part – Testing (self-explanatory, just basic tests to make sure the CRM works).</li>
            </ul>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D284;
